import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";

import { useTranslation } from "react-i18next";

import WOW from 'wowjs';

export const ProductoDetallePage = () => {
    const { t, i18n } = useTranslation();

    const { id: idParam } = useParams();

    const [products, setProducts] = useState([]);
    const [producto, setProducto] = useState([]);

    function chargeInfo() {
        const producto = products.find((item) => item.slug === idParam);
        setProducto(producto)
    }

    function shuffle(array) {
        let currentIndex = array.length, randomIndex;

        while (currentIndex !== 0) {
            randomIndex = Math.floor(Math.random() * currentIndex);
            currentIndex--;

            // Intercambio
            [array[currentIndex], array[randomIndex]] = [
                array[randomIndex], array[currentIndex]];
        }

        return array;
    }

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    }, [idParam]);

    useEffect(() => {
        import(`../../core/data/${i18n.language}Productos.json`)
            .then((module) => setProducts(module.default))
            .catch((err) => console.error("Error loading products", err));
    }, [i18n.language]);

    useEffect(() => {
        if (products.length == 0) return;

        chargeInfo();
    }, [products, idParam])

    useEffect(() => {
        new WOW.WOW().init();
    }, []);

    if (!producto) {
        return (
            <>
                <section>
                    <div className="hero-section position-relative banner-section gap-2">
                        <img className="icon wow fadeInUp" src="/assets/img/new/elemento.png" />
                        <h1 className="wow fadeInUp">Error</h1>
                        <img className="icon wow fadeInUp" src="/assets/img/new/elemento2.png" />
                    </div>
                </section>
                <section className="section wow fadeIn">
                    <div
                        className="container"
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                        }}
                    >
                        <div className="misc-wrapper text-center">
                            <h1 className="mb-2 mx-2 text-center" style={{ lineHeight: "6rem", fontSize: "6rem" }}>404</h1>
                            <h4 className="mb-2 mx-2">No se encontro el producto 🤔</h4>
                            <p className="mb-6 mx-2">Verifique la url o intente mas tarde.</p>
                        </div>
                    </div>
                </section>
            </>
        );
    }

    return (
        <>
            <section>
                <div className="hero-section position-relative banner-section gap-2">
                    <img className="icon wow fadeInUp" src="/assets/img/new/elemento.png" />
                    <h1 className="wow fadeInUp">Detalle del producto</h1>
                    <img className="icon wow fadeInUp" src="/assets/img/new/elemento2.png" />
                </div>
            </section>
            <section className="section">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6 text-center">
                            <img
                                src={`/assets/img/products/${producto.imagen}`}
                                alt={producto.nombre}
                                className="img-fluid rounded mb-3 wow bounceInDown"
                                style={{ objectFit: "cover" }}
                            /></div>
                        <div className="col-md-6 d-flex flex-column justify-content-center">
                            <h1 className="title-section wow fadeIn">{producto.nombre}</h1>
                            <p className="sub-title-product mt-1 mb-4 wow fadeInUp">{producto.categoria}</p>
                            <p className="text-muted wow fadeInDownBig" style={{ textAlign: "justify" }}>{producto.descripcion}</p>

                            <div className='d-flex mt-5 gap-2'>

                                <a
                                    href={`https://wa.me/+573150459980?text=Hola, quiero cotizar el producto: ${producto.nombre}`}
                                    target="_blank"
                                    to={`/productos`}
                                    title="Cotizar"
                                >
                                    <img className="" width={40} src={`/assets/img/new/whatsapp.svg`} />
                                </a>
                                <a
                                    href={`https://www.facebook.com/share/1A8APBFLgx/?mibextid=wwXIfr`}
                                    target="_blank"
                                    to={`/productos`}
                                    title="Facebook Agroesana"
                                >
                                    <img className="" width={40} src={`/assets/img/new/facebook.svg`} />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="section">
                <div className="container">
                    <div className='d-flex flex-column align-items-start mb-2'>
                        <h1 className='title-section mb-4'>{t("productsInterest")}</h1>
                    </div>
                    <div className="row row-cols-1 row-cols-md-3 row-cols-sm-2 row-cols-lg-4 p-0">
                        {
                            shuffle(Array.from(products)).slice(0, 4).map((item, index) => {
                                return (
                                    <div className="col d-flex justify-content-center mb-5" key={index}>
                                        <div className='card-product shadow-default py-3'>
                                            <div className='image-product-card'>
                                                <img className="" src={`/assets/img/products/${item.imagen}`} />
                                            </div>
                                            <div className='card-product-body'>

                                                <div className="card-product-info">
                                                    <p className='sub-title-product mx-3 mt-0 wow fadeInUp'>{item.categoria}</p>
                                                    <h1 className='title-product mx-3 wow fadeInUp'>{item.nombre}</h1>
                                                </div>

                                                <div className='card-product-footer d-flex justify-content-center mx-3 mt-4'>
                                                    <Link
                                                        to={`/productos/${item.slug}`}
                                                        className={`default-btn`}>
                                                        {t("seeProduct")}
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
            </section >
        </>
    )
}